import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import type { FormField } from '../../../interfaces/form.interface';
import { InputType } from '../../../interfaces/input.interface';

@Component({
    selector: 'app-reactive-calendar-field',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './calendar-field.component.html',
})
export class ReactiveCalendarFieldComponent<T> {
    @Input() field!: FormField<T>;

    @Input() model!: FormGroup;

    @Input() isEditable = false;

    @Input() describedById = '';

    @Input() isInvalid = false;

    public readonly inputType = InputType;
}
